import { SVG, SVGProps } from './svg'

export function IconDrawingSettingLock(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M15 5.5A2.5 2.5 0 0 0 12.5 8v4.5H10A2.5 2.5 0 0 0 7.5 15v8c0 1.4 1.1 2.5 2.5 2.5h12c1.4 0 2.5-1.1 2.5-2.5v-8c0-1.4-1.1-2.5-2.5-2.5h-8.5V8c0-.8.7-1.5 1.5-1.5h2c.8 0 1.5.7 1.5 1.5v1a.5.5 0 0 0 1 0V8c0-1.4-1.1-2.5-2.5-2.5h-2Zm-5 8c-.8 0-1.5.7-1.5 1.5v8c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-8c0-.8-.7-1.5-1.5-1.5H10Zm4.5 4.5a1.5 1.5 0 0 1 3 0v2a1.5 1.5 0 0 1-3 0v-2Zm1.5-.5c-.3 0-.5.2-.5.5v2a.5.5 0 0 0 1 0v-2c0-.3-.2-.5-.5-.5Z"
      />
    </SVG>
  )
}
